import { useQuery } from '@tanstack/react-query';
import { useDemo } from '../../../demo/DemoContext';
import { dateKey } from '../../../shared/lib/format';
import { useWorkspace } from '../../stores';
import { invoicesApi } from '../api/invoicesApi';
export function useInvoices(month?: string) {
  const { isDemo, store, scopeKey, today, timezone } = useWorkspace();
  const demo = useDemo(); const chosen = month && /^\d{4}-(0[1-9]|1[0-2])$/.test(month) ? month : today.slice(0, 7);
  const from = chosen + '-01'; const d = new Date(from + 'T12:00:00Z'); d.setUTCMonth(d.getUTCMonth() + 1); d.setUTCDate(0); const to = d.toISOString().slice(0, 10);
  return useQuery({ queryKey: [...scopeKey, 'invoices', from, to, isDemo ? demo.revision : 0], queryFn: ({ signal }) => isDemo ? Promise.resolve(demo.invoices.filter(i => i.store_id === store?.id && dateKey(i.bill_date_ms, timezone) >= from && dateKey(i.bill_date_ms, timezone) <= to)) : invoicesApi.list(from, to, timezone, signal), enabled: Boolean(store?.id), staleTime: 30_000 });
}
